const defaultRuntime = {
  getBaseUrl: () => '',
  getToken: () => null,
  getZoneId: () => null,
  getItem: () => null,
  setItem: () => undefined,
  removeItem: () => undefined,
  createId: () => `${Date.now()}-${Math.random().toString(36).slice(2)}`,
  onUnauthorized: () => undefined,
  onZoneEcho: () => undefined,
};

let runtime = { ...defaultRuntime };

export function configureRuntime(overrides = {}) {
  runtime = { ...runtime, ...overrides };
  return runtime;
}

export function resetRuntime() {
  runtime = { ...defaultRuntime };
  return runtime;
}

export function getRuntime() {
  return runtime;
}
